query CollectionTypeEdit($id: ID!) {
  collectionType(id: $id) {
    id
    title
    showInSearch
    collectionDisplayMode
  }
}
